<template>
  <div>
    <v-dialog v-model="dialogtrfdana" persistent max-width="500">
      <v-card>
        <v-card-title class="primary white--text">Transfer Dana Antas Kas</v-card-title>
        <v-card-text>
          <div class="mt-6">
            <v-select
                label="Asal"
                item-text="name"
                item-value="code"
                v-model="trfdana.idsumber"
                :items="account"
            ></v-select>
          </div>
          <div class="mt-0">
            <v-select
                label="Tujuan"
                item-text="name"
                item-value="code"
                v-model="trfdana.idtujuan"
                :items="account"
            ></v-select>
          </div>
          <div><v-text-field type="number" v-model="trfdana.jumlah" label="Jumlah Transfer" autofocus></v-text-field></div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn elevation="0" class="red" @click="setdialogtrfdana(false)" dark>Tutup</v-btn>
          <v-btn elevation="0" :loading="loading" @click="dotransfer" class="primary">Transfer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DialogTrfDanaAntasKas',
  data: () => ({
    trfdana: {
      idsumber: '01',
      idtujuan: '02',
      jumlah: 0
    }
  }),
  computed: {
    ...mapState('AdmStore', ['account', 'dialogtrfdana', 'loading'])
  },
  methods: {
    ...mapActions('AdmStore', ['getAccount', 'setdialogtrfdana', 'trfdanaAntarkas']),
    dotransfer () {
      this.trfdanaAntarkas(this.trfdana)
    }
  }
}
</script>

<style scoped>

</style>
